import React, { useEffect, useState } from 'react';
import { Modal } from '../../components/Modal';
import { ModalFooter } from '../../components/ModalFooter';
import { MfaTokenInput } from '../../components/MfaTokenInput';
import { AlertBlock } from '../../components/AlertBlock';
import { useReactivateProject } from '../../hooks/useProject';
import { api } from '../../services/api';
import { getAccountService } from '../../services/angular-bridge';

interface Props {
  projectId: string;
  projectName: string;
  onClose: () => void;
}

export function ReactivateModal({ projectId, projectName, onClose }: Props) {
  const [token, setToken] = useState('');
  const reactivate = useReactivateProject(projectId);
  const phone = getAccountService().Get()?.phone as string | undefined;

  useEffect(() => {
    api.post('/account/mfa/start').catch(() => {});
  }, []);

  const handleSubmit = () => {
    reactivate.mutate({ token, projectName }, { onSuccess: onClose });
  };

  return (
    <Modal title="Re-Activate Project" onClose={onClose} footer={
      <ModalFooter
        onClose={onClose}
        onNext={handleSubmit}
        nextLabel="Re-Activate"
        nextDisabled={token.length < 7}
        saving={reactivate.isPending}
        savingLabel="Reactivating…"
      />
    }>
      <AlertBlock type="info">
        Please enter the token provided by your{' '}
        <a target="_blank" rel="noreferrer" href="https://www.authy.com/app/mobile/">
          <i className="fas fa-mobile-phone" aria-hidden="true" /> Authy App
        </a>
        {phone ? <> or via text message to {phone}</> : null}.<br /><br />
        To change the phone number on file, visit your{' '}
        <a href="#!/settings">account settings</a>.
      </AlertBlock>
      <div className="form-group">
        <h4>Project: <small><i className="fas fa-gavel" aria-hidden="true" /> {projectName}</small></h4>
      </div>
      <MfaTokenInput value={token} onChange={setToken} disabled={reactivate.isPending} />
      {reactivate.isError && (
        <p className="text-danger">Failed to re-activate project. Check your token and try again.</p>
      )}
    </Modal>
  );
}
